import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { IconButton } from '..';
import { translate } from '../../services';
import { getConfiguration } from '../../util';
import { superCodeDispatcher, messageDispatcher, combineDispatchers, identityState } from '../../store';


export class SuperCodeComponent extends React.Component{
  constructor( props ) {
    super( props );
    this.state = {
      isCreatingSupercode : false
    };
  }
  addMessage = ( messageText, messageType= 'confirmation', timeout= 0 ) => {
    return this.props.addMessage( {  timeout: timeout, messageText: translate( messageText ), messageType: messageType  } )
  }
  create = () => {
    const { product, user } = this.props;
    this.setState( { isCreatingSupercode: true } );
    this.props.createSuperCode( getConfiguration( product, user ) )
    .then(
      superCodeResponse => {
        if( superCodeResponse.data.errors && superCodeResponse.data.errors.length ){
          this.addMessage( "Some error occured while creating supercode", "error", 0 );
        }
        else{
          this.addMessage( superCodeResponse.data.response );
        }
      }
    )
    .catch(
      () => this.addMessage( "Some error occured please try again", "error", 0 )
    )
    .then( () => this.setState( { isCreatingSupercode: false } ) );
  }

  render(){
    const { disabled, hidden } = this.props
    const label = translate( "Create Supercode" );
    return <IconButton
      tooltip={ label }
      className="blue-button"
      onClick={ this.create }
      text={ label }
      disabled={ disabled || this.state.isCreatingSupercode  }
      hidden={ hidden }
    />;
  }
}
SuperCodeComponent.propTypes = {
  product: PropTypes.shape( {} ),
  disabled: PropTypes.bool,
  hidden: PropTypes.bool
}
export const SuperCode = connect( identityState, combineDispatchers( superCodeDispatcher, messageDispatcher ))( SuperCodeComponent );